import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=48ecbe3e&"
import script from "./Switch.vue?vue&type=script&lang=ts&"
export * from "./Switch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports